// src/Section/Home/Terravia.jsx

import React from "react";
import Banner from "../../Section/Home/Banner/banner.jsx";
import Desktop from "../../Media/Header/Desktop/Desktop_Office.webp";
import Mobile from "../../Media/Header/Mobile/Mobile_Office.webp";
import About from "../../Section/Detail/about/about.jsx";
import Promo from "../../Section/Home/Promo/promo.jsx";
import Lokasi from "../../Section/Home/Lokasi/lokasi.jsx";
import Terraviadata from "./Komersial.json";
import promoData from "./promo.json";
import logo from "../../Media/RumahLogo/Ruko BSD (1).png";
import hardsell from "./hardsell_com.webp";
import Produk from "../Commercial/Enchante/Komersial1.jsx";

import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";

const Terravia = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        logo={logo}
        judul={Terraviadata.judul}
        Deskripsi={Terraviadata.deskripsi}
      />
      <Promo
        image={hardsell}
        title={promoData.title}
        points={promoData.points}
        whatsapp={promoData.whatsapp}
      />
      <Produk />

      <Surrounding />

      <Lokasi />
    </div>
  );
};

export default Terravia;
